// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader-container {\n  display: flex;\n  justify-content: center;\n  height: 100vh;\n}", "",{"version":3,"sources":["webpack://./src/ui/Loader/Loader.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AACF","sourcesContent":[".loader-container {\n  display: flex;\n  justify-content: center;\n  height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
